import { safeSanitize } from '../../utils/safe_sanitize';

angular.module("LeasePilot").controller("ManageUsersController", [
  "$scope",
  "$mdDialog",
  "UsersService",
  "UserHelperService",
  function($scope, $mdDialog, UsersService, UserHelperService) {
    // Helper function to escape Angular expressions and HTML to prevent XSS
    function escapeForTemplate(text) {
      if (!text || typeof text !== 'string') return text || '';
      // Remove Angular interpolation markers first to prevent expression evaluation
      let cleanText = text.replace(/{{.*?}}/g, '');
      // Strip all HTML tags and attributes to prevent XSS
      cleanText = safeSanitize(cleanText, {
        allowedTags: [],
        allowedAttributes: [],
      });
      // Additional escape for template literal context (HTML attributes)
      return cleanText
        .replace(/&/g, '&amp;')
        .replace(/"/g, '&quot;');
    }

    $scope.type = "";

    $scope.init = async function() {
      window.track.event(new LoadUserManagementEvent());
      
      $scope.isProcessing = false;
      
      $scope.users.forEach(u => {
        if (window.user.id === u.id) {
          u.isCurrentUser = true;
        }
      });

      const availableBuildingIds = new Set($scope.buildings.map(building => building.id));

      Object.values($scope.partners).forEach(partner => {
        partner.buildings = partner.buildings.filter(buildingId => availableBuildingIds.has(buildingId));
      });

      $scope.partners = Object.values($scope.partners);
    };

    $scope.showCreateUserDialog = function() {
      window.track.event(new LoadCreateNewUserEvent());
      $mdDialog.show({
        template: '<md-dialog><user-form-modal type="create" /></md-dialog>',
        parent: angular.element(document.body),
        fullscreen: false
      });
    };

    $scope.showEditUserDialog = function(user) {
      window.track.event(new LoadEditUserEvent({
        id: user.id,
      }));
      $mdDialog.show({
        template: `<md-dialog><user-form-modal type="update" id="${escapeForTemplate(String(user.id))}" first-name="${escapeForTemplate(user.firstName || '')}" last-name="${escapeForTemplate(user.lastName || '')}" email="${escapeForTemplate(user.email)}" role="${escapeForTemplate(user.role.replace(" ", "_").toLowerCase())}" /></md-dialog>`,
        parent: angular.element(document.body),
        fullscreen: false
      });
    };

    $scope.showResetPasswordDialog = function(user) {
      $scope.currentUser = user;
      $mdDialog.show({
        template: `<md-dialog><reset-password-modal id="${escapeForTemplate(String(user.id))}" email="${escapeForTemplate(user.email)}" /></md-dialog>`,
        parent: angular.element(document.body),
        fullscreen: false
      });
    };

    $scope.activateUser = function(user) {
      UserHelperService.activate(user.id).then(
        response => {
          window.track.event(new ActivateUserEvent({
            id: user.id,
          }));
          window.location.reload();
        },
        error => {
          throw error;
        }
      );
    };

    $scope.deactivateUser = function(user) {
      UserHelperService.deactivate(user.id).then(
        response => {
          window.track.event(new DeactivateUserEvent({
            id: user.id,
          }));
          window.location.reload();
        },
        error => {
          throw error;
        }
      );
    };

    $scope.showDeleteUserDialog = function(user) {
      $scope.currentUser = user;
      $mdDialog.show({
        template: `<md-dialog><delete-user-confirmation-modal id="${escapeForTemplate(String(user.id))}" email="${escapeForTemplate(user.email)}" /></md-dialog>`,
        parent: angular.element(document.body),
        fullscreen: false
      });
    };

    $scope.create = async function() {
      const isValid = await UserHelperService.validate({
        type: "create",
        firstName: $scope.firstName,
        lastName: $scope.lastName,
        email: $scope.email,
        password: $scope.password,
        role: $scope.role,
      });

      $scope.isValid = isValid;

      if (isValid.all) {
        $scope.safeApply(() => {
          $scope.isProcessing = true;
        });
        
        const data = {
          firstName: $scope.firstName,
          lastName: $scope.lastName,
          email: $scope.email,
          password: $scope.password,
          role: $scope.role,
        };

        const promise = UserHelperService.create(data);
        
        promise.then(
          response => {
            window.track.event(new CreateNewUserEvent(data));
            window.location.href = "/admin_area/users";
          },
          error => {
            console.log(error);
            // TODO:
          }
        );
      }
    };

    $scope.update = async function() {
      const isValid = await UserHelperService.validate({
        type: "update",
        firstName: $scope.firstName,
        lastName: $scope.lastName,
        email: $scope.email,
        role: $scope.role,
      });

      $scope.isValid = isValid;

      if (isValid.all) {
        $scope.safeApply(() => {
          $scope.isProcessing = true;
        });

        const data = {
          id: $scope.id,
          firstName: $scope.firstName,
          lastName: $scope.lastName,
          email: $scope.email,
          role: $scope.role,
        };

        const promise = UserHelperService.update(data);
        
        promise.then(
          response => {
            window.track.event(new EditUserEvent(data));
            window.location.href = "/admin_area/users";
          },
          error => {
            console.log(error);
            // TODO:
          }
        );
      }
    };

    $scope.generatePassword = async function() {
      window.track.event(new GeneratePasswordEvent());
      $scope.password = UserHelperService.generatePassword();
      await $scope.validateBeforeCreate("create");

      setTimeout(() => {
        document.querySelector("#password").select();
      });
    };

    $scope.validateBeforeCreate = async function() {
      const isValid = await UserHelperService.validate({
        type: "create",
        firstName: $scope.firstName || "",
        lastName: $scope.lastName || "",
        email: $scope.email || "",
        password: $scope.password || "",
        role: $scope.role
      });

      $scope.safeApply(() => {
        $scope.isValid = isValid;
      });
    };

    $scope.validateBeforeUpdate = async function() {
      const isValid = await UserHelperService.validate({
        type: "update",
        firstName: $scope.firstName || "",
        lastName: $scope.lastName || "",
        email: $scope.email || "",
        role: $scope.role
      });

      $scope.safeApply(() => {
        $scope.isValid = isValid;
      });
    };

    $scope.cancel = function() {
      if ($scope.type === "create") {
        window.track.event(new CancelCreateNewUserEvent());
      } else if ($scope.type === "update") {
        window.track.event(new CancelEditUserEvent({
          id: $scope.id,
        }));
      }
      window.location.href = "/admin_area/users";
    };
  }
]);
